// Auto-generated from i18n.de.json

export const I18n = {
  a11y: {
    appLink: {
      appleStore: 'Laden im Apple Store',
      googlePlay: 'Laden für Android',
    },
    button: {
      close: 'Schließen',
      closeDialog: 'Dialog schließen',
      gameInfo: 'Informationen zu: {{game}}',
      information: 'Infos',
      muteVideo: 'Video stummschalten',
      pauseVideo: 'Video pausieren',
      playVideo: 'Video abspielen',
      productSwitcher: 'Produktwechsler, öffnet Link zu {{name}}',
      tab: 'Tab, zeigt zugehörige Inhalte an',
      unmuteVideo: 'Video mit Ton wiedergeben',
    },
    gameTile: {
      rank: 'Platz {{rank}}',
    },
    heading: {
      appStoreLinks: 'App Store-Links',
      lobby: 'Tipico Games',
      navigation: 'Hauptnavigation',
      panicButton: 'Selbstsperre',
      paymentProviders: 'Zahlungsanbieter',
      providers: 'Anbieter',
      search: 'Suche',
    },
    image: {
      coverArtFor: 'Spielcover von {{name}}',
      flameIcon: 'Flammensymbol',
      paymentMethod: 'Zahlungsmethode: {{name}}',
      rewardIcon: 'Belohnungssymbol',
      sectionIcon: 'Symbol für {{title}}',
      volatilityRating: 'Volatilität: {{value}} von {{max}}',
      wonderWheel: 'Glücksrad',
    },
    nav: {
      skipToMain: 'Zur Hauptnavigation springen',
    },
    note: {
      search:
        'Diese Suche ermöglicht es Ihnen, Spiele, Studios und Kategorien zu finden. Geben Sie mindestens zwei Zeichen ein, um die Suche zu starten. Ergebnisse werden unten angezeigt.',
    },
    status: {
      filterResults: '{{count}} Ergebnisse nach Filterung',
      noFilterResults: 'Keine Ergebnisse gefunden',
      searchResults: '{{count}} Ergebnisse gefunden für: {{searchTerm}}',
      selectedCount: '{{count}} von {{required}} ausgewählt',
    },
    video: {
      gameTile: 'Vorschau-Video des Spiels {{name}}',
      gamificationTeaser:
        'Tipico Logo mit Icons für tägliches Auftaktturnier, 5-Tage-Login-Mission, 25 Freispiele-Belohnung',
      lobbyBanner: 'Werbebanner-Video für Spielangebote und Aktionen',
    },
  },
  activityLane: {
    activePlayers: 'Aktive Spieler',
    game: {
      justWon: 'Jetzt gewonnen',
      state: {
        viral: 'Viral',
      },
      winSize: {
        big: 'Big',
        club1000x: 'Club 1.000x',
        mega: 'Mega',
      },
    },
    title: 'Trending LIVE',
  },
  appUpdateRequired: {
    content: 'Bleib im Spiel! Installiere die neueste Version, um die Tipico Games App weiter nutzen zu können.',
    title: 'Neue App-Version',
    updateNow: 'Jetzt installieren',
  },
  base: {
    account: 'Konto',
    all: 'Alle',
    back: 'Zurück',
    backToHome: 'Zurück zur Startseite',
    categories: 'Kategorien',
    confirm: 'Bestätigen',
    demo: 'Demo',
    deposit: 'Einzahlen',
    exactProgress: '{{amount}} übrig',
    expires: 'Läuft ab',
    faq: 'FAQ',
    for: 'für',
    game: 'Spiel',
    gameBalance: 'Guthaben',
    games: 'Spiele',
    general: 'Allgemein',
    hide: 'Verbergen',
    home: 'Startseite',
    logOutReason: {
      generic: {
        message: 'Logg dich bitte nochmal ein.',
        secondaryCta: 'Support kontaktieren',
        title: 'Du wurdest ausgeloggt',
      },
      inactivity: {
        message: 'Du warst 30 Minuten inaktiv und deine Sitzung ist abgelaufen.',
        secondaryCta: 'Zur Startseite',
        title: 'Du wurdest ausgeloggt',
      },
      oasis: {
        message:
          'Du wurdest ausgeloggt. Während der Sperre kannst du dich nur in dein Konto einloggen oder unseren Support kontaktieren.',
        secondaryCta: 'Support kontaktieren',
        title: 'Du bist im bundesweiten Sperrsystem OASIS gesperrt',
      },
      panic: {
        message:
          'Du wurdest ausgeloggt. Während der Sperre kannst du dich nur in dein Konto einloggen oder unseren Support kontaktieren.',
        secondaryCta: 'Support kontaktieren',
        title: 'Du hast die 24-Stunden-Sofortsperre aktiviert',
      },
      unauthenticated: {
        message: 'Etwas ist schiefgelaufen, bitte logge dich nochmal ein.',
        title: 'Ausgeloggt',
      },
    },
    login: 'Einloggen',
    loginAndPlay: 'Einloggen und spielen',
    loginRequiredMessage: 'Bitte melde dich an, um auf diese Seite zugreifen zu können.',
    loginRequiredTitle: 'Anmeldung erforderlich',
    logoButton: 'Tipico Logo, zurück zur Startseite',
    logoutSuccessful: 'Du hast dich ausgeloggt.',
    more: 'Mehr',
    moreInfo: 'Mehr Infos',
    newCustomerModalCTA: 'Individuelle Limits setzen',
    newCustomerModalHint:
      "*Bitte bestätige oder passe dein monatliches anbieterübergreifendes Einzahlungslimit für das länderübergreifende Glücksspielauswertesystem LUGAS an. Mehr Infos findest du in unseren <a href='{{link}}'>Allgemeinen Geschäftsbedingungen</a>.",
    newCustomerModalSecondaryCTA: 'Aktuelles Limit bestätigen',
    newCustomerModalTitle: 'Tauche ein in die Welt von Tipico Games',
    next: 'Weiter',
    noResultsFound: 'Wir konnten keine Ergebnisse finden',
    notifications: 'Neuigkeiten',
    oftenSearched: 'Häufig gesucht',
    ok: 'OK',
    play: 'Spielen',
    playNow: 'Jetzt spielen',
    previous: 'Zurück',
    providers: 'Anbieter',
    register: 'Registrieren',
    responsibleGamingLogo: 'Webseite der gemeinsamen Glücksspielbehörde der Länder',
    search: 'Suchen',
    searchFor: 'Suche nach Spielen oder Anbietern',
    searchResults: 'Suchergebnisse',
    show: 'Anzeigen',
    showMore: 'Mehr anzeigen',
    similar: 'Ähnlich wie {{name}}',
    studios: 'Anbieter',
    themes: {
      dark: 'Dunkelmodus',
      light: 'Hellmodus',
    },
    tryAgain: 'Nochmal versuchen',
    viewAll: 'Alle anzeigen',
    viewAllShort: 'Alle',
    welcomeOffer: {
      desktop: {
        subtitle: '100% Bonus bis zu 100€',
        title: 'WILLKOMMENS- ANGEBOT',
      },
      mobile: {
        subtitle: '100% Bonus bis zu 100€',
        title: 'WILLKOMMENSANGEBOT',
      },
    },
  },
  bestMatch: {
    banner: {
      cta: 'Slots finden',
      subtitle: 'In 3 Schritten zu deinen Favoriten',
      title: 'Finde deine Top-Spiele',
    },
    card: {
      playAria: '{{game}} spielen',
    },
    carouselTitle: 'Für dich ausgewählt',
    continue: 'Weiter',
    finalCTA: 'Top-Slots ansehen',
    mechanics: {
      button: 'Funktionen entdecken',
      modalTitle: 'Funktionen',
      subtitle: 'Features auswählen',
      title: 'Wähle deine Features',
      unavailable: 'Für deine Auswahl nicht verfügbar',
    },
    moreMatches: 'Mehr Treffer',
    result: {
      title: 'Deine Top 3 Spiele',
    },
    themes: {
      subtitle: 'Themen auswählen',
      title: 'Wähle mindestens 3 Kategorien',
    },
    volatility: {
      average: {
        subtitle: 'Mittlere Gewinne – gelegentlich',
        title: 'Ausgeglichen',
      },
      high: {
        subtitle: 'Große Gewinne – selten',
        title: 'Hoch',
      },
      low: {
        subtitle: 'Kleine Gewinne – häufig',
        title: 'Niedrig',
      },
      rangeEnd: 'groß',
      rangeStart: 'häufig',
      title: 'Wähle die Volatilität',
      veryhigh: {
        subtitle: 'Die größten Gewinne – sehr selten',
        title: 'Sehr hoch',
      },
      verylow: {
        subtitle: 'Kleinste Gewinne – sehr häufig',
        title: 'Sehr niedrig',
      },
    },
  },
  browser: {
    offline: {
      message: 'Wir versuchen uns wieder zu verbinden.',
      retry: 'Nochmal versuchen',
      title: 'Keine Internetverbindung',
    },
  },
  category: {
    tiles: {
      placeholder: {
        empty: 'Wir konnten keine Spiele finden. Versuche andere Filter oder Kategorien.',
        loading: 'Lädt…',
      },
    },
  },
  clubThousandItems: {
    page: {
      noClubThousand: 'Der Club 1.000x konnte nicht geladen werden.',
    },
  },
  compliance: {
    activationCoolOffMinimized: {
      message: 'Logge dich beim anderen Anbieter aus und versuch’s nochmal.',
      title: 'Du bist noch woanders aktiv',
    },
    activationCoolOffModal: {
      paragraph1: 'Logge dich beim anderen Anbieter aus und versuch’s nochmal. Das gilt auch für Sportwetten.',
      paragraph2: 'Aus regulatorischen Gründen kannst du nur bei einem Anbieter aktiv sein.',
      title: 'Du bist noch bei einem anderen Anbieter aktiv',
    },
    activationCoolOffOverModal: {
      message: 'Deine Wartezeit ist vorbei und du kannst jetzt weiterspielen.',
    },
    breakIsOver: {
      button: 'Weiterspielen',
      message: 'Deine 5-minütige Wartezeit ist vorbei und du kannst jetzt weiterspielen.',
      title: 'Die Wartezeit ist vorbei',
    },
    clear: 'Verstanden',
    confirmLocationModal: {
      actionButtonText: 'Ja, ich bin in Schleswig-Holstein',
      altActionButtonText: 'Nein',
      text: 'Dieses Angebot ist nur in diesem Bundesland verfügbar.',
      title: 'Bist du in Schleswig-Holstein?',
    },
    coolOffModal: {
      message:
        'Deine Sitzung wurde vom Regulierungssystem LUGAS beendet, weil du inaktiv warst oder dich kürzlich bei einem anderen Anbieter eingeloggt hast. Das gilt auch, wenn du dich bei Tipico Sports oder Games aus- und wieder einloggst. Warte bitte 5 Minuten und versuch’s nochmal.',
      moreInfoMessage1: 'Spiele verantwortungsbewusst und im Rahmen deiner Möglichkeiten.',
      moreInfoMessage2:
        'Falls du gerade bei einem anderen Anbieter eingeloggt warst oder auch bei Tipico Sportwetten, musst du eine 5-minütige Pause machen, bevor du Tipico Games spielen kannst.',
      moreInfoTitle: 'Mehr über die Wartezeit',
      title: 'Mach eine Pause',
    },
    deactivation: {
      message:
        'Du warst für längere Zeit inaktiv und wurdest automatisch aus der anbieterübergreifenden Zentraldatei (LUGAS) abgemeldet.',
      title: 'Sitzung beendet',
    },
    limitedMode: {
      accountNotGermanKycVerified: {
        cta: 'Jetzt verifizieren',
        message: 'Verifiziere dein Konto, um wieder spielen zu können.',
        title: 'Dein Konto ist eingeschränkt',
      },
      blockedByHighRisk: {
        cta: 'Zu meinem Konto',
        message: 'Du kannst aktuell nicht spielen. Mehr Infos findest du in deinem Konto.',
        title: 'Dein Konto ist gesperrt',
      },
      blockedByOasis: {
        cta: 'Zu meinem Konto',
        message:
          'Du kannst aktuell nicht wetten oder einzahlen, da du dich bei einem anderen Anbieter gesperrt hast und ein Eintrag in der anbieterübergreifenden Sperrdatenbank OASIS vorliegt.',
        title: 'Dein Konto ist gesperrt',
      },
      generic: {
        cta: 'Zu meinem Konto',
        message: 'Du kannst aktuell nicht spielen. Mehr Infos findest du in deinem Konto.',
        title: 'Dein Konto ist eingeschränkt',
      },
      holiday: {
        altCta: 'Abmelden',
        cta: 'Konto wieder aktivieren',
        message: 'Du hast dein Konto bis zum {{date}} deaktiviert. Du kannst es jederzeit wieder aktivieren.',
        messageIndefinite: 'Du hast dein Konto deaktiviert. Du kannst es jederzeit wieder aktivieren.',
        title: 'Dein Konto ist deaktiviert',
      },
      imposedExclusion: {
        cta: 'Zu meinem Konto',
        message: 'Du kannst aktuell nicht spielen. Mehr Infos findest du in deinem Konto.',
        title: 'Dein Konto ist gesperrt',
      },
      movingAbroad: {
        altCta: 'Abmelden',
        cta: 'Konto wieder aktivieren',
        message: 'Du hast dein Konto bis zum {{date}} deaktiviert. Du kannst es jederzeit wieder aktivieren.',
        messageIndefinite: 'Du hast dein Konto deaktiviert. Du kannst es jederzeit wieder aktivieren.',
        title: 'Dein Konto ist deaktiviert',
      },
      noMoreInterest: {
        altCta: 'Abmelden',
        cta: 'Konto wieder aktivieren',
        message: 'Du hast dein Konto bis zum {{date}} deaktiviert. Du kannst es jederzeit wieder aktivieren.',
        messageIndefinite: 'Du hast dein Konto deaktiviert. Du kannst es jederzeit wieder aktivieren.',
        title: 'Dein Konto ist deaktiviert',
      },
      notSatisfiedWithBonusOrPromotions: {
        altCta: 'Abmelden',
        cta: 'Konto wieder aktivieren',
        message: 'Du hast dein Konto bis zum {{date}} deaktiviert. Du kannst es jederzeit wieder aktivieren.',
        messageIndefinite: 'Du hast dein Konto deaktiviert. Du kannst es jederzeit wieder aktivieren.',
        title: 'Dein Konto ist deaktiviert',
      },
      notSatisfiedWithOdds: {
        altCta: 'Abmelden',
        cta: 'Konto wieder aktivieren',
        message: 'Du hast dein Konto bis zum {{date}} deaktiviert. Du kannst es jederzeit wieder aktivieren.',
        messageIndefinite: 'Du hast dein Konto deaktiviert. Du kannst es jederzeit wieder aktivieren.',
        title: 'Dein Konto ist deaktiviert',
      },
      other1: {
        cta: 'Zu meinem Konto',
        message: 'Du kannst aktuell nicht spielen. Mehr Infos findest du in deinem Konto.',
        title: 'Dein Konto ist gesperrt',
      },
      other: {
        altCta: 'Abmelden',
        cta: 'Konto wieder aktivieren',
        message: 'Du hast dein Konto bis zum {{date}} deaktiviert. Du kannst es jederzeit wieder aktivieren.',
        messageIndefinite: 'Du hast dein Konto deaktiviert. Du kannst es jederzeit wieder aktivieren.',
        title: 'Dein Konto ist deaktiviert',
      },
      panicButtonSelfExcluded: {
        altCta: 'Ausloggen',
        cta: 'Zu meinem Konto',
        message:
          'Du hast die 24-Std.-Sofortsperre genutzt, du kannst unser Produkt nach Ablauf der 24 Stunden wieder vollständig nutzen.',
        title: 'Dein Konto ist eingeschränkt',
      },
      poiDocumentsExpired: {
        cta: 'Jetzt verifizieren',
        message: 'Verifiziere dein Konto, um wieder spielen zu können.',
        title: 'Dein Konto ist eingeschränkt',
      },
      reactivationHint:
        'Falls du dein Konto bereits reaktiviert hast, melde dich bitte ab und erneut an, damit die Änderungen wirksam werden.',
      restrictionLifted: 'Dein Konto wurde wieder aktiviert',
      selfExclusion: {
        cta: 'Zu meinem Konto',
        message: 'Du kannst aktuell nicht spielen. Mehr Infos findest du in deinem Konto.',
        title: 'Dein Konto ist gesperrt',
      },
      technicalIssues: {
        altCta: 'Abmelden',
        cta: 'Konto wieder aktivieren',
        message: 'Du hast dein Konto bis zum {{date}} deaktiviert. Du kannst es jederzeit wieder aktivieren.',
        messageIndefinite: 'Du hast dein Konto deaktiviert. Du kannst es jederzeit wieder aktivieren.',
        title: 'Dein Konto ist deaktiviert',
      },
      thirtyDayWindowGermanKyc: {
        cta: 'Jetzt verifizieren',
        message: 'Verifiziere dein Konto, um wieder spielen zu können.',
        title: 'Dein Konto ist eingeschränkt',
      },
      unsatisfied: {
        altCta: 'Abmelden',
        cta: 'Konto wieder aktivieren',
        message: 'Du hast dein Konto bis zum {{date}} deaktiviert. Du kannst es jederzeit wieder aktivieren.',
        messageIndefinite: 'Du hast dein Konto deaktiviert. Du kannst es jederzeit wieder aktivieren.',
        title: 'Dein Konto ist deaktiviert',
      },
    },
    longPlay: {
      lowerMessage:
        'Sobald die Pause vorbei ist, geht das Spiel da weiter, wo du aufgehört hast. Schließt du das Fenster, wird es beendet.',
      message: 'Du warst sehr aktiv und musst daher eine kurze Pause machen.',
      subtitle: 'Du kannst gleich weiterspielen',
      title: 'Kurze Auszeit',
    },
    nightPlay: {
      deadlineMinimized: 'Du bist in der Auszeit',
      message: 'Wir beenden gleich dein Spiel. Du warst sehr aktiv in der Nacht und musst daher eine Pause machen.',
      title: 'Mach eine Auszeit',
    },
    oasisError: {
      action: 'Nochmal versuchen',
      altAction: 'Schließen',
      title: 'Ein Fehler ist aufgetreten, bitte versuche es später erneut.',
    },
    oasisJustSuspended: {
      text: 'Für dein Konto ist aktuell eine Sperre aktiv. Du kannst erst wieder spielen, wenn die Frist abgelaufen ist.',
      title: 'Dein Konto ist derzeit gesperrt',
    },
    realityCheckModal: {
      finishedMinimized: {
        button: 'Jetzt weiterspielen',
        text: 'Setze dein Glück in Bewegung und dreh die Walzen.',
        title: 'Die Wartezeit ist vorbei',
      },
      inGame: {
        finishedMessage: 'Setze dein Glück in Bewegung und dreh die Walzen.',
        finishedTitle: 'Die Wartezeit ist vorbei',
        inProgressMessage: 'Du warst 60 Minuten aktiv und musst jetzt eine 5-minütige Pause machen.',
        inProgressTitle: 'Kurze Auszeit',
        inProgressWarning:
          'Sobald die Pause vorbei ist, geht das Spiel da weiter, wo du aufgehört hast. Schließt du das Fenster, wird das Spiel beendet.',
      },
      moreInfo: {
        text: 'Dein Spielerschutz ist oberste Priorität. Nach 60 Minuten spielen musst du eine 5-minütige Pause machen, damit du weiterspielen kannst.',
        title: 'Mehr über die Zeitkontrolle',
      },
      ongoing: {
        text: 'Du kannst gerade nicht spielen, aber die 5-minütige Pause ist gleich vorbei.',
        title: 'Du bist in der Pause',
      },
      ongoingMinimized: {
        text: 'Du kannst gleich weiterspielen.',
        title: 'Mach eine Pause',
      },
      required: {
        text: 'Du warst 60 Minuten aktiv und musst jetzt eine 5-minütige Pause machen.',
        textGame:
          'Du warst 60 Minuten aktiv und musst jetzt eine 5-minütige Pause machen. Du kannst <b>nach der Pause weiterspielen</b>.',
        title: 'Zeitkontrolle',
      },
      startButton: 'Pause beginnen',
    },
    retryActivation: {
      button: 'Nochmal versuchen',
      claimConflict: {
        checkClaimButton: 'Nochmal versuchen',
      },
      initial: {
        paragraph1: 'Aus regulatorischen Gründen kannst du nur bei einem Anbieter aktiv sein.',
        paragraph2: 'Logge dich beim anderen Anbieter aus und versuch’s nochmal. Das gilt auch für Sportwetten.',
        title: 'Du bist noch bei einem anderen Anbieter aktiv',
      },
      message: 'Bitte versuche es später nochmal. Stelle sicher, dass deine Internetverbindung funktioniert.',
      retry: {
        paragraph1: 'Logge dich beim anderen Anbieter aus und versuch’s nochmal. Das gilt auch für Sportwetten.',
        paragraph2: 'Aus regulatorischen Gründen kannst du nur bei einem Anbieter aktiv sein.',
        title: 'Du scheinst immer noch bei einem anderen Anbieter aktiv zu sein',
      },
      title: 'Etwas ist schiefgelaufen',
    },
    rgProtection: {
      button: 'Verstanden',
      message:
        '<p>Wir haben bei deinem Spielverhalten Auffälligkeiten bemerkt.</p><p>Wenn du dein Spielverhalten einschätzen möchtest, kannst du unseren <a href="{{selbsttestUrl}}" target="_blank" rel="noopener">Selbsttest machen</a>. Bei Fragen kannst du auch unser <a href="{{spielerschutzUrl}}" target="_blank" rel="noopener">Spielerschutz-Team kontaktieren</a>.</p>',
      optOutText: 'Hinweis nicht nochmal anzeigen',
      title: 'Dein Schutz steht an erster Stelle',
    },
    stateDisclaimerModal: {
      actionButton: 'Zu Tipico Games',
      bannerSubtitle: 'bei Tipico Games',
      bannerTitle: 'Bis zu 100 € Neukundenbonus',
      text: 'Dein Standort liegt außerhalb von Schleswig-Holstein. Wechsle zu Tipico Games.',
      title: 'Tipico Casino ist nur in Schleswig-Holstein verfügbar',
    },
    statisticsModal: {
      daysAmount: 'Deine 30-Tage-Übersicht',
      loss: 'Verlust:',
      wagering: 'Einsätze:',
      warning:
        'Glücksspiel kann süchtig machen. Spiele verantwortungsbewusst. Mehr Infos findest du <a target="_blank" href=\'{{link}}\'>hier</a>.',
      win: 'Gewinn:',
      winLoss: 'Gewinn/Verlust:',
    },
  },
  deadline: {
    hour: 'Uhr',
    until: 'Bis',
  },
  errors: {
    generic: {
      text: 'Bitte versuche es später nochmal.',
      title: 'Etwas ist schiefgelaufen',
    },
  },
  flyer: {
    lowBalance: {
      cta: 'Einzahlen',
      subtitle: 'Dein Guthaben:',
      title: 'Guthaben aufladen?',
    },
  },
  footer: {
    helpCenterText: 'Du hast Fragen? Schau in unserem <u lang="en">Help Center</u> vorbei.',
    links: {
      aboutUs: 'Über uns',
      accessibility: 'Erklärung zur Barrierefreiheit',
      blog: 'Tipico Games Blog',
      cookieSettings: 'Cookie-Einstellungen',
      dataProtection: 'Datenschutzrichtlinie',
      gamesInfo: 'Auszahlungsquoten',
      imprint: 'Impressum',
      offerConditions: 'Bedingungen',
      payoutPercentages: 'Auszahlungsquoten',
      playerProtection: 'Spielerschutz',
      sitemap: 'Sitemap',
      termsAndConditions: 'Geschäftsbedingungen',
      termsOfOffer: 'Angebotsbedingungen',
    },
    responsibleGaming:
      '<p>18+. Glücksspiel kann süchtig machen. Spiele verantwortungsbewusst. Weitere Informationen findest du auf unserer <a href="https://games.risk-in-safe-hands.com/" target="_blank">Spielerschutzseite</a>. Beratung und Hilfe für Betroffene und Angehörige gibt es auf <a href="https://bundesweit-gegen-gluecksspielsucht.de" target="_blank">bundesweit-gegen-gluecksspielsucht.de</a> und <a href="https://www.check-dein-spiel.de" target="_blank"> www.check-dein-spiel.de</a>. </p>\n<p>Der Tipico Games Ltd wurde mit Bescheid vom 06.10.2022 die behördliche <a href="https://www.gluecksspiel-behoerde.de/de/erlaubnisfaehigesgluecksspiel/whitelist" target="_blank">Erlaubnis</a> zur Veranstaltung von virtuellen Automatenspielen erteilt.&nbsp;(behördlich zugelassener Veranstalter von virtuellen Automatenspielen). Tipico Games Ltd. steht unter der Aufsicht der <a href="https://www.gluecksspiel-behoerde.de/de/" target="_blank">Gemeinsamen Glücksspielbehörde</a> der Länder. Die registrierte Adresse der Tipico Games Ltd ist Tipico Tower, Vjal Portomaso, STJ 4011 St. Julian’s, Malta</p>',
  },
  gameInfo: {
    gameName: 'Spielname',
    hitFrequency: 'Trefferfrequenz',
    labels: {
      exclusive: 'EXKLUSIV',
      new: 'NEU',
      top10: 'TOP 10',
    },
    maxWin: 'Max. Gewinn',
    minmax: 'Min. / Max. Einsatz',
    numBetMax: 'Max Number of Bets',
    numBetMin: 'Min Number of Bets',
    payout: 'Max. Auszahlung',
    reels: 'Walzen',
    rtp: 'RTP',
    seoMetaDescription:
      'Spiele {{title}} online bei Deutschlands Nummer 1 um echtes Geld! Tipico Games bietet dir die besten Slots von {{provider}}! ✚ bis zu 100 Euro Bonus!',
    seoMetaTitle: 'Spiele {{title}} online um echtes Geld | Tipico Games',
    studio: 'Anbieter',
    volatility: 'Volatilität',
    volatilityText:
      'Volatilität bezieht sich auf die Häufigkeit und Höhe der potenziellen Gewinne. Spiele mit hoher Volatilität zahlen seltener, dafür höhere Beträge, aus.',
    winlines: 'Anzahl der Gewinnlinien',
  },
  gamePage: {
    discoverDrawer: {
      exitGame: 'Spiel verlassen',
      nothingFound: 'Nichts gefunden',
      searchResults: 'Suchergebnisse',
      similarTo: 'Ähnlich wie {{game}}',
    },
    panicButton: 'Für die 24-Std.-Sofortsperre, {{seconds}} Sekunden drücken',
    rtpLine: {
      maxWin: 'MAX. GEWINNWAHRSCHEINLICHKEIT: ',
      rtp: 'RTP',
    },
  },
  gamificationTeaserModal: {
    message:
      'Schließe Missionen ab und nimm an Turnieren teil, um exklusive Boni freizuschalten und Preise zu gewinnen.',
  },
  incentive: {
    base: {
      activeBonus: 'Aktiver Bonus',
      freespins: 'Freispiele',
      missions: 'Missionen',
      rewards: 'Belohnungen',
      title: 'Hi {{username}}',
      tournaments: 'Turniere',
    },
    bundle: {
      abortedBundleMessage: 'Nicht abgeschlossen',
      chooseGame: 'Wähle ein Spiel',
      continue: 'Fortsetzen',
      expiredBundleMessage: 'Nicht rechtzeitig abgeschlossen',
      fromTomorrow: 'Ab morgen',
      instructions: 'So funktioniert’s:',
      mission: {
        pendingMessage: 'Schließe alle oben genannten Stufen ab, um dies freizuschalten',
        rewardDescriptionBonusMoney: 'Bonusguthaben',
        rewardDescriptionFallback: 'für {{gameName}}',
      },
      noPastBundlesSubTitle:
        "Verfügbare Missionen findest du im Tab <a href='{{link}}' alt={{alt}} id={{id}}>Aktuelle</a>.",
      noPastBundlesTitle: 'Noch keine vergangenen Missionen',
      optIn: 'Teilnehmen',
      optOut: 'Mission abbrechen',
      optOutModal: {
        cancelButton: 'Mission fortsetzen',
        confirmButton: 'Mission abbrechen',
        message: 'Deine bisherigen Fortschritte gehen verloren und die Mission wird beendet.',
        title: 'Mission abbrechen?',
      },
      optedIn: 'Aktiv',
      play: 'Spielen',
      warningModal: {
        accept: 'Teilnehmen',
        decline: 'Ohne Mission spielen',
        subTitle:
          'Du hast das Spiel gestartet, ohne an der Mission teilzunehmen. Nimm jetzt teil, um deinen Fortschritt zu sichern.',
        title: 'Willst du an der Mission teilnehmen?',
      },
    },
    bundles: {
      placeholderText: 'Vergangene Missionen anzeigen',
      placeholderTitle: "Aktuell keine Missionen. Morgen gibt's wieder neue!",
    },
    mission: {
      aborted: 'Abgebrochen',
      completed: 'Abgeschlossen',
      current: 'Aktuelle',
      ends: 'Endet',
      expired: 'Abgelaufen',
      inStage: 'in Stufe {{number}}',
      past: 'Vergangene',
      reward: 'Belohnung',
      startedOn: 'Begonnen am',
      step: 'Stufe',
      steps: 'Stufen',
      totalPrize: 'Gesamtgewinn',
      totalPrizeToWin: 'Belohnung',
    },
    missionBar: {
      missionCompleted: 'Mission abgeschlossen!',
      win: 'gewonnen',
    },
    reward: {
      FSCredited: 'Insgesamt erhaltene Freispiele',
      active: 'Umzusetzen',
      available: 'Verfügbar',
      bonusMoneyOutFSAmount: '{{amount}} Gewinne aus Freispielen',
      bonusMoneyRewardAmount: '{{amount}} Bonus',
      bonusMoneyWinnings: 'Gutgeschriebener Bonus',
      campaign: 'Kampagne',
      claim: 'Belohnung abholen',
      completedOn: 'Abgeschlossen am',
      consumed: 'Verbraucht',
      creditedOn: 'Gutgeschrieben am',
      decline: 'Belohnung ablehnen',
      declineModal: {
        cancelButton: 'Belohnung abholen',
        confirmButton: 'Belohnung ablehnen',
        message: 'Dann verfällt die Belohnung und kann nicht mehr abgeholt werden.',
        title: 'Belohnung ablehnen?',
      },
      details: 'Details',
      earned: 'Deine Belohnung:',
      errorTile: 'Beholung derzeit nicht verfügbar',
      expired: 'Abgelaufen',
      expiredOn: 'Abgelaufen am',
      expiresOn: 'Läuft ab am',
      forfeited: 'Abgebrochen',
      forfeitedOn: 'Abgebrochen Am',
      freeSpinsUsed: 'Insgesamt erhaltene Freispiele',
      miniGame: {
        claim: 'Los gehts',
        continue: 'Fortsetzen',
        decline: 'Ablehnen',
        subtitle: 'Drehe und gewinne',
        title: 'Wonder Fortune',
      },
      missionCompleted: 'Mission abgeschlossen',
      noBMRewards: 'Keine aktiven Boni verfügbar',
      noBMRewardsHint:
        "Deine vergangenen Boni findest du im Tab <a href='{{link}}' alt={{alt}} id={{id}}>Vergangen</a>.",
      noRewardSubtitle:
        'Schließe <a href="{{missionsLink}}" alt="{{missionsLinkAlt}}" id="{{missionId}}">Missionen</a> ab oder spiele  <a href="{{tournamentsLink}}" alt="{{tournamentsLinkAlt}}" id="{{tournamentsId}}">Turniere</a>, um Belohnungen zu erhalten.',
      noRewardTitle: 'Zurzeit keine Belohnungen',
      optOutModal: {
        cancelButton: 'Belohnung behalten',
        confirmButton: 'Belohnung stornieren',
        message: 'Dann verfällt die Belohnung und ist nicht mehr verfügbar.',
        title: 'Willst du die Belohnung stornieren?',
      },
      over: 'Übrig',
      past: 'Vergangen',
      placeholderText: 'Vergangene Belohnungen anzeigen',
      placeholderTitle: 'Aktuell keine Belohnungen',
      reward: 'Belohnung',
      tacTitle: 'Bedingungen',
      tournamentCompleted: 'Du hast den {{position}}. Platz belegt',
      unsubscribe: 'Belohnung stornieren',
      upTo: 'Bis',
      used: 'Genutzt',
      wonInFreeSpins: 'Gewonnen',
    },
    termsAndConditions: 'Bedingungen',
    tournaments: {
      abandoned: 'Vorbei',
      bonusMoneyWinnings: 'Bonusgeld gewonnen',
      buttons: {
        chooseGame: 'Wähle ein Spiel',
        play: 'Spielen',
      },
      cancelled: 'Abgesagt',
      checkYourResult: 'Zum Ergebnis',
      chooseGame: 'Verfügbare Spiele',
      completed: 'Abgeschlossen',
      ended: 'Beendet',
      endedOn: 'Ende',
      endsAt: 'Endet',
      finalPosition: 'Platz',
      freeSpinWinnings: 'Freispiele gewonnen',
      howTo: 'So funktioniert’s:',
      info: 'Info',
      join: 'Teilnehmen',
      leaderboard: 'Rangliste',
      leaderboardTable: {
        player: 'Spieler',
        points: 'Punkte',
        pointsShort: 'Pkt.',
        position: 'Platz',
        reward: 'Belohnung',
        you: 'Du',
      },
      live: 'Live',
      noLeaderboardAvailable: 'Die Rangliste wird angezeigt, sobald das Turnier beginnt.',
      noPastTournamentsTitle: 'Noch keine vergangenen Turniere',
      noRewards: 'Diesmal keine Belohnung',
      noTournamentsTitle: 'Keine verfügbaren Turniere',
      placeholderText: 'Vergangene Turniere anzeigen',
      placeholderTitle: 'Aktuell keine Turniere',
      players: '{{value}} Spieler',
      point: 'Punkt',
      points: 'Punkte',
      pointsCalculation: 'Wie werden Punkte berechnet?',
      progressBar: {
        ended: 'Das Turnier ist beendet',
        endedShort: 'Turnier beendet.',
      },
      rewardsTotal: 'Gewinne',
      startedOn: 'Start',
      startsAt: 'Beginnt',
      termsAndConditions: 'Bedingungen',
      totalReward: 'Gewinnpool',
      userPosition: '{{value}} Platz',
      waitForResult: 'Ergebnisse werden geprüft …',
      waitForStart: 'Warten auf den Turnierstart',
      warningModal: {
        accept: 'Teilnehmen',
        decline: 'Ohne Turnier spielen',
        subTitle:
          'Du hast das Spiel gestartet, ohne an dem Turnier teilzunehmen. Nimm jetzt teil, um deinen Fortschritt zu sichern.',
        title: 'Willst du an dem Turnier teilnehmen?',
      },
    },
  },
  languageSwitcherModal: {
    acceptButtonText: 'Ja, zu {{preferredLanguage}} wechseln',
    cancelButtonText: 'Nein, bleiben Sie auf Deutsch',
    message:
      'Derzeit ist unser Produkt in {{currentLanguage}}, aber wir haben festgestellt, dass Ihr Browser auf {{preferredLanguage}} als bevorzugte Sprache eingestellt ist. Möchten Sie zu {{preferredLanguage}} wechseln?',
    title: 'Sprache wechseln',
  },
  languages: {
    de: 'Deutsch',
    en: 'English',
  },
  limitConfirmation: {
    prompt: {
      cta1: 'Mein Limit von {{value}} bestätigen',
      cta2: 'Limit anpassen',
      text: 'Es geht um dein anbieterübergreifendes Einzahlungslimit LUGAS.',
      title: 'Setze jetzt dein neues Einzahlungslimit',
      warning: "Verbindung fehlgeschlagen. Versuch's bitte nochmal.",
      yourNewLimitText: 'Dein neues Limit:',
      yourNewLimitValue: '{{value}}',
    },
    success: {
      cta: 'Fertig',
      text: 'Ein niedrigeres Limit gilt sofort. Eine Erhöhung wird spätestens nach 8 Tagen wirksam.',
      title: 'Dein Einzahlungslimit wird auf {{value}} gesetzt',
    },
  },
  lugasSessionTimer: {
    activeSession: 'Aktive Sitzung',
  },
  maintenance: {
    gameModalText:
      'Versuche es bitte später nochmal. In der Zwischenzeit wartet eine Vielzahl anderer Spiele auf dich.',
    gameTile: 'Das Spiel ist gerade nicht verfügbar',
    gamificationCTA2026: 'Verstanden',
    gamificationSubtitle:
      'Wir führen gerade geplante Wartungsarbeiten durch. Alle anderen Inhalte sind davon nicht betroffen und normal nutzbar.',
    gamificationSubtitle2026:
      'Hier gibt’s im Moment nichts zu tun.\nSchon bald warten neue Herausforderungen und Belohnungen auf dich.',
    gamificationTitle: 'Bald geht es hier weiter',
    gamificationTitle2026: 'Wir arbeiten gerade an Verbesserungen',
    reloadButton: 'Seite neu laden',
    subtitle: 'Wir führen derzeit geplante Wartungsarbeiten durch.',
    title: 'Wir sind bald zurück',
  },
  mod: {
    account: {
      bonusMoney: 'Bonusgeld',
      bonusMoneyCut: 'Dein Bonusgeld ist nicht auszahlbar. Du musst erst die Umsatzbedingungen erfüllen.',
      depositWagering: 'Einzahlungsumsatz',
      depositWageringCut:
        'Du musst noch {{amount}} umsetzen, damit du diesen Betrag auszahlen kannst. Du musst den Einzahlungsbetrag 1x umsetzen bevor du auszahlen kannst.',
      email: 'E-Mail',
      gameHistory: {
        freeround: 'Freispiele',
        gameCanceled: 'Abgebrochen',
        gameOpen: 'Offen',
        title: 'Spielrundenverlauf',
        wageredAmount: 'Umgesetzter Betrag',
        winningAmount: 'Gewonnener Betrag',
      },
      history: {
        noItemFound:
          'Für den ausgewählten Zeitraum liegen keine Einträge vor. Du hast entweder noch keinen Verlauf oder musst deine <span role="button" tabindex="0">Filtereinstellungen</span> anpassen.',
      },
      limitsAndClosure: {
        deactivateCard: {
          header: 'Konto deaktivieren oder selbstausschließen',
          text: 'Du kannst eine vorübergehende oder unbestimmte Pause einlegen oder dein Konto schließen.',
        },
        limitsCard: {
          header: 'Limits',
          text: 'Setze dir ein tägliches, wöchentliches oder monatliches Einzahlungs-, Verlust- oder Einsatzlimit.',
        },
        limitsHistoryCard: {
          header: 'Limitverlauf',
          text: 'Eine genaue Übersicht über den Verlauf deiner Limits.',
        },
        title: 'Kontoverwaltung & Limits',
      },
      limitsHistory: {
        depositLimitHistory: 'Einzahlungslimitverlauf',
        wageringAndLossLimitHistory: 'Einsatz- und Verlustlimitverlauf',
      },
      logout: {
        cta: 'Angemeldet bleiben',
        logout: 'Abmelden und Wartezeit starten',
        subtitle: 'Dann kannst du in den nächsten 5 Minuten nicht spielen.',
        title: 'Willst du dich ausloggen?',
      },
      noLimitsSet: 'Es sind derzeit keine Einträge vorhanden, da noch kein Limit gesetzt wurde.',
      password: 'Passwort',
      paymentHistory: {
        filterModal: {
          filterOptions: {
            all: 'Alle',
            deposit: 'Einzahlung',
            other: 'Andere',
            withdrawal: 'Auszahlung',
          },
        },
        paymentStatuses: {
          completed: 'Abgeschlossen',
          failed: 'Fehlgeschlagen',
          initiated: 'Eingeleitet',
        },
        paymentTypes: {
          bonus_withdrawal: 'Bonusauszahlung',
          credit: 'Gutschrift',
          debit: 'Abbuchung',
          deposit: 'Einzahlung',
          refund: 'Rückzahlung',
          withdrawal: 'Auszahlung',
        },
        title: 'Transaktionsverlauf',
      },
      transactionHistory: {
        amount: 'Betrag',
        filter: 'Filter',
        filterModal: {
          apply: 'Anwenden',
          dateLimitsMessage: 'Um über 12 Monate alte Daten anzufordern, wende dich bitte an unseren <a>Support</a>.',
          dateRange: 'Zeitraum',
          from: 'Von',
          outcome: 'Typ',
          outcomes: {
            all: 'Alle',
            has_bet: 'Einsatz',
            has_win: 'Gewinne',
          },
          reset: 'Zurücksetzen',
          title: 'Filter',
          to: 'Bis',
        },
        finalBalance: 'Endguthaben',
        id: 'ID',
        initialBalance: 'Anfangsguthaben',
        title: 'Transaktionsverlauf',
      },
      wageringAndLossLimitHistoryPage: {
        applied: 'Angewendet',
        daily: 'Täglich',
        loss: 'Verlust',
        monthly: 'Monatlich',
        noLimit: 'Kein Limit',
        requested: 'Angefragt',
        spending: 'Einsatz',
        title: 'Einsatz- und Verlustlimitverlauf',
        weekly: 'Wöchentlich',
        willApply: 'Wird angewendet',
      },
      withdrawable: 'Auszahlbar',
      withdrawableCut: 'Diesen Betrag kannst du auszahlen.',
    },
    bonus: {
      activeRewards: 'Aktive Angebote',
      bonuses: 'Aktiv',
      campaignDataIsMissing: 'Kampagnendaten nicht verfügbar',
      claimNow: 'Aktivieren',
      conflictSubscribedSubtitle: 'Dein vorheriges Einzahlungsangebot ist vielleicht nicht mehr verfügbar.',
      conflictSubscribedTitle: 'Du hast dein Angebot geändert',
      deactivationMessage: {
        limitReached:
          'Das Angebot wurde automatisch storniert, da du dein jährliches Limit für Angebote und Rabatte erreicht hast.',
        limitReachedLink: '',
      },
      dummyMessageOptedIn: 'Du bist angemeldet',
      eligibleGames: 'Berechtigte Spiele',
      errorClaimMessageText: 'Das Angebot konnte nicht beansprucht werden. Bitte versuche es nochmal.',
      errorClaimMessageTitle: 'Etwas ist schiefgelaufen',
      errorConflictActionButton: 'Zu den Angebotsdetails',
      errorConflictText:
        'Du kannst dich pro Einzahlung nur für ein Angebot anmelden.<br /><br />Um ein anderes Angebot zu nutzen, musst du dein aktuelles abschließen oder stornieren. Das stornierte Angebot verfällt.',
      errorConflictTitle: 'Du hast noch ein ausgewähltes Einzahlungsangebot',
      errorOptInMessageText: 'Bitte versuche es nochmal.',
      errorOptInMessageTitle: 'Anmeldung fehlgeschlagen',
      forfeitCTA: 'Angebot stornieren',
      keepBonus: 'Angebot behalten',
      myPromotions: 'Angebote',
      noActiveMessage: "Entdecke passende <a href='{{link}}'>Angebote</a> für dich.",
      noActiveTitle: 'Du hast keine aktiven Angebote',
      noPastRewards: 'Du hast keine vergangenen Angebote',
      noPromotionMessage: 'Schau später wieder vorbei, um spannende Angebote zu entdecken.',
      noPromotionTitle: 'Keine Angebote verfügbar',
      optIn: 'Beanspruchen',
      optInCtaButton: 'Zu den aktiven Angeboten',
      optOut: 'Angebot stornieren',
      optOutMessage:
        'Wenn du dein Angebot stornierst, dann kannst du dieses nicht mehr aktivieren und dein Fortschritt sowie der Bonusbetrag verfallen.',
      optedIn: 'Angemeldet',
      pastIncremental: 'Stufenangebote',
      pastOneTime: 'Einmaliger Bonus',
      pastRewards: 'Vergangen',
      promotions: 'Angebote',
      skip: 'Einzahlen ohne Angebot',
      welcomeMessage: 'Hier sind deine Angebote:',
      welcomeTitle: 'Ein Einzahlungsbonus wartet auf dich',
    },
    login: {
      apiMessage: {
        customer: {
          unauthorized: 'Deine Anmeldedaten sind nicht korrekt. Versuche es nochmal oder setze dein Passwort zurück.',
        },
      },
      logIn: 'Einloggen',
      loginToAccount: 'Melde dich mit deinem Tipico Konto an.',
      welcomeBack: 'Willkommen zurück!',
    },
  },
  navigation: {
    accountMenu: {
      bonus: 'Angebote',
      details: 'Meine Daten',
      gameHistory: 'Spielrunden',
      helpCenter: 'Help Center',
      hotlinks: 'Schnellzugriff',
      info: 'Infos',
      limits: 'Limits',
      limitsAndClosure: 'Kontoverwaltung & Limits',
      logout: 'Abmelden & Inaktivieren',
      paymentHistory: 'Transaktionen',
      payments: 'Zahlungen',
      preferences: 'Hilfe und Präferenzen',
      settings: 'Einstellungen',
      themeSwitcher: 'Design',
      themeSwitcherHeader: 'Darstellung',
      verification: 'Kontoverifizierung',
      withdraw: 'Auszahlen',
    },
    navbar: {
      deposit: 'Einzahlen',
      discover: 'Entdecken',
      home: 'Startseite',
      leave: 'Verlassen',
      missions: 'Challenges',
      promo: 'Angebote',
      search: 'Suche',
    },
  },
  notificationPermission: {
    benefits: {
      newGames: {
        description: 'Die neuesten Slots und Anbieter.',
        title: 'Neue Games',
      },
      offers: {
        description: 'Exklusive Freispiele, Missionen und Turniere.',
        title: 'Angebote & Aktionen',
      },
      security: {
        description: 'Infos zu Status und wichtige Updates.',
        title: 'Konto & Sicherheit',
      },
    },
    cta: {
      activate: 'Mitteilungen aktivieren',
      dismiss: 'Später',
    },
    subtitle: 'Wir schicken dir etwa 4 Push-Mitteilungen pro Woche.',
    title: 'Bleib im Game per Push',
  },
  oasisMaintenance: {
    button: 'OK, verstanden',
    header: 'Sitzung abmelden',
    text: 'OASIS wird derzeit gewartet. Um den Vorschriften zu entsprechen, müssen wir Sie abmelden. Sie können sich erneut anmelden, sobald die Wartung abgeschlossen ist.',
  },
  onboarding: {
    base: {
      depositIcon: {
        description: 'Lade dein Guthaben auf und starte direkt durch.',
        title: 'Einzahlen',
      },
      gamification: {
        description:
          'Schalte exklusive Angebote und Erfolge\nfrei, indem du Missionen abschließt\nund an Turnieren teilnimmst.',
        title: 'Challenges',
      },
      userIcon: {
        description: 'Verwalte deine persönlichen Einstellungen und Daten',
        title: 'Mein Konto',
      },
    },
    doneBtnText: 'Verstanden',
    doneBtnText2: "Los geht's",
    nextBtnText: 'Weiter',
    promotions: {
      bonuses: {
        description: 'Verfolge den Fortschritt deiner laufenden Angebote.',
        title: 'Aktive Angebote',
      },
      pastRewards: {
        description: 'Sieh dir deine abgeschlossenen und abgelaufenen Angebote an.',
        title: 'Vergangene Angebote',
      },
      promotions: {
        description: 'Entdecke deine exklusiven Angebote und finde das Passende für dich.',
        title: 'Verfügbare Angebote',
      },
    },
  },
  pageNotFound: {
    backHomeButton: 'Zurück zur Startseite',
    header: 'Seite nicht gefunden',
    text: 'Diese Seite existiert nicht oder wurde entfernt. Keine Sorge, das ist noch nicht das Ende des Spiels! Gehen Sie zurück zur Startseite, die Walzen warten auf Sie!',
  },
  panic: {
    footerCTA: '24-Std.-Sofortsperre',
    footerText:
      'Halte für die 24-Stunden-Sofortsperre den Button 3 Sekunden gedrückt. Wenn du die Sperre aktivierst, erfolgt ein Eintrag in die anbieterübergreifende Sperrdatenbank OASIS.',
    infoText: 'Bitte beachte, dass ein Eintrag in die anbieterübergreifende Sperrdatenbank OASIS erfolgt.',
    infoTitle: '24 Stunden Sofortsperre',
    modalText: 'Dein Konto ist für 24 Stunden gesperrt und du kannst dich nicht einloggen.',
    modalTitle: 'Gesperrt für 24 Stunden',
  },
  payment: {
    bonusLabel: 'Dein Bonus:',
    maintenance: {
      copy: 'Wir verbessern gerade unser Zahlungssystem. Ein- und Auszahlungen sind währenddessen vorübergehend nicht möglich. Wir arbeiten mit Hochdruck daran, den Service schnellstmöglich wieder bereitzustellen. Vielen Dank für deine Geduld.',
      cta: 'Verstanden',
      title: 'Wartungsarbeiten im Kassenbereich',
    },
  },
  paymentTeaserModal: {
    items: {
      applepayDescription: 'eWallet',
      googlepayDescription: 'eWallet',
      klarnaDescription: 'Bankkonto',
      mastercardDescription: 'Kredit-/Debitkarte',
      paypalDescription: 'Meistgenutzten Methode',
      paysafecardDescription: 'Mit Mypaysafe-Konto',
      skrillDescription: 'eWallet',
      skrillOneTapDescription: 'eWallet',
      trustlyDescription: 'Bankkonto',
      visaDescription: 'Kredit-/Debitkarte',
    },
    title: 'Zahlungsmethoden',
  },
  phoneSubmission: {
    button: 'Weiter',
    text: 'Hinterlege deine Handynummer: Verpasse keine Angebote und mache dein Konto noch sicherer.',
  },
  phoneVerification: {
    button: 'Weiter',
    text: 'Bestätige deine Handynummer: Verpasse keine Angebote und mache dein Konto noch sicherer.',
  },
  playerArea: {
    favorites: 'Favoriten',
    lastPlayed: 'Zuletzt gespielt',
  },
  popup: {
    accountStatus: {
      AML: {
        docsRequested: {
          text: 'Lade einen Nachweis deines Einkommens oder Vermögens hoch, damit dein Konto nicht weiter eingeschränkt wird.',
          title: 'Dein Konto ist eingeschränkt.',
        },
        docsReview: {
          text: 'Wir prüfen gerade deine Nachweise. Wir melden uns bei dir, sobald wir fertig sind.',
        },
        docsUncooperative: {
          text: 'Lade einen Nachweis deines Einkommens oder Vermögens hoch, um die Einschränkungen aufzuheben.',
          title: 'Dein Konto ist eingeschränkt.',
        },
        infoRequested: {
          text: 'Um weitere Einschränkungen deines Kontos zu verhindern, beantworte ein paar einfache Fragen zu deiner finanziellen Situation. Es dauert weniger als 1 Minute.',
          title: 'Dein Konto ist eingeschränkt.',
        },
        infoRequestedSoft: {
          text: 'Beantworte ein paar einfache Fragen zu deiner finanziellen Situation, es dauert weniger als 1 Minute.',
          title: 'Vermeide künftige Einschränkungen.',
        },
        infoRequestedUncooperative: {
          text: 'Um die Einschränkungen deines Kontos aufzuheben, beantworte ein paar einfache Fragen zu deiner finanziellen Situation. Es dauert weniger als 1 Minute.',
          title: 'Dein Konto ist eingeschränkt.',
        },
      },
      DOCUMENTS_EXPIRY: {
        action: 'Jetzt verifizieren',
        text: 'Das ist nötig, damit dein Konto aktiv bleibt und dauert nur 1 Minute',
        title: 'Verifiziere dich erneut',
      },
      KYC: {
        action: 'Jetzt verifizieren',
        text: 'Dein Konto wird bald eingeschränkt. Verifiziere dich jetzt, um es vollständig freizuschalten.',
      },
      POA: {
        action: 'Jetzt verifizieren',
        text: 'Dein Konto wird bald eingeschränkt. Verifiziere dich jetzt, um es vollständig freizuschalten.',
      },
      POA_SONIO: {
        action: 'Jetzt verifizieren',
        text: 'Dein Konto wird bald eingeschränkt. Verifiziere dich jetzt, um es vollständig freizuschalten.',
      },
      RG: {
        docsInconclusive: {
          text: 'Der hochgeladene Nachweis hat nicht ausgereicht. Um dein Konto aktiv zu halten, brauchen wir einen neuen Nachweis deines Einkommens oder Vermögens.',
          title: 'Lade bitte einen neuen Nachweis hoch',
        },
        docsInconclusiveHigh: {
          text: 'Der hochgeladene Nachweis hat nicht ausgereicht. Um dein Konto zu reaktivieren, brauchen wir einen neuen Nachweis deines Einkommens oder Vermögens.',
          title: 'Lade bitte einen neuen Nachweis hoch',
        },
        docsRequested: {
          text: 'Um dein Konto aktiv zu halten, brauchen wir einen Nachweis deines Einkommens oder Vermögens.',
          title: 'Lade bitte einen finanziellen Nachweis hoch',
        },
        docsRequestedHigh: {
          text: 'Lade bitte einen Nachweis deines Einkommens oder Vermögens hoch, um es zu reaktivieren.',
          title: 'Dein Konto ist eingeschränkt',
        },
        docsReview: {
          text: 'Wir informieren dich, sobald die Prüfung abgeschlossen ist.',
          title: 'Dein Nachweis wird geprüft',
        },
        docsReviewHigh: {
          text: 'Wir informieren dich, sobald die Prüfung abgeschlossen ist. Bis dahin bleibt dein Konto eingeschränkt.',
          title: 'Dein Nachweis wird geprüft',
        },
        docsUncooperative: {
          text: 'Um dein Konto aktiv zu halten, brauchen wir einen Nachweis deines Einkommens oder Vermögens.',
          title: 'Lade bitte einen finanziellen Nachweis hoch',
        },
        docsUncooperativeHigh: {
          text: 'Lade bitte einen Nachweis deines Einkommens oder Vermögens hoch, um dein Konto zu reaktivieren.',
          title: 'Dein Konto ist eingeschränkt',
        },
        infoInconclusive: {
          text: 'Prüfe bitte deine E-Mails, um dein Konto aktiv zu halten.',
          title: 'Die Prüfung ist abgeschlossen',
        },
        infoInconclusiveHigh: {
          text: 'Prüfe bitte deine E-Mails, um dein Konto zu reaktivieren.',
          title: 'Die Prüfung ist abgeschlossen',
        },
        infoRequested: {
          text: 'Beantworte 2 kurze Fragen zu deinem Spielverhalten, um dein Konto aktiv zu halten.',
          title: 'Dein Schutz steht an erster Stelle',
        },
        infoRequestedHigh: {
          text: 'Beantworte 2 kurze Fragen zu deinem Spielverhalten, um es zu reaktivieren.',
          title: 'Dein Konto ist eingeschränkt',
        },
        infoReview: {
          text: 'Wir informieren dich, sobald die Prüfung abgeschlossen ist.',
          title: 'Deine Antworten werden geprüft',
        },
        infoReviewHigh: {
          text: 'Wir informieren dich, sobald die Prüfung abgeschlossen ist. Bis dahin bleibt dein Konto eingeschränkt.',
          title: 'Deine Antworten werden geprüft',
        },
        infoUncooperative: {
          text: 'Beantworte 2 kurze Fragen zu deinem Spielverhalten. Das dauert weniger als 1 Minute.',
          title: 'Dein Schutz steht an erster Stelle',
        },
        infoUncooperativeHigh: {
          text: 'Beantworte 2 kurze Fragen zu deinem Spielverhalten, um es zu reaktivieren.',
          title: 'Dein Konto ist eingeschränkt',
        },
      },
      'document-expiry-soon': {
        action: 'Jetzt verifizieren',
        text: 'Dein Ausweis läuft bald ab. Verifiziere dich mit einem gültigen Dokument, damit dein Konto nicht eingeschränkt wird.',
      },
      'pam:tipico-account-aml-docs-review-uncooperative': {
        action: 'Verstanden',
        text: 'Du kannst aktuell nicht spielen, aus- oder einzahlen. Versuch’s in ein paar Stunden bitte nochmal.',
        title: 'Deine Nachweise werden geprüft',
      },
      'pam:tipico-account-error': {
        action: 'Zu Mein Konto',
        altAction: 'Zum Support',
        text: 'Prüfe dein Konto, um die Einschränkungen aufzuheben.',
        title: 'Dein Konto ist eingeschränkt',
      },
      'pam:tipico-account-sanction-open': {
        action: 'Verstanden',
        text: 'Du kannst aktuell nicht spielen, aus- oder einzahlen. Versuch’s in ein paar Stunden bitte nochmal.',
        title: 'Dein Konto wird geprüft',
      },
      'pam:tipico-account-sanction-sl-rejected': {
        action: 'Verstanden',
        text: 'Du kannst aktuell nicht spielen, aus- oder einzahlen. Versuch’s in ein paar Stunden bitte nochmal.',
        title: 'Dein Konto wird geprüft',
      },
      'pam:tipico-account-self-excluded': {
        action: 'Zu Mein Konto',
        altAction: 'Zum Support',
        text: 'Du hast die 24 Stunden sperre aktiviert bzw. wurdest von uns oder einem anderen Anbieter gesperrt. Du kannst dich erst wieder einloggen, wenn die Zeit vorbei ist.',
        title: 'Dein Konto ist derzeit gesperrt',
      },
      'pam:tipico-account-sow-docs-uncooperative': {
        action: 'Dokumente hochladen',
        text: 'Du kannst aktuell nicht spielen. Lade einen Nachweis zu deinem Einkommen oder Vermögen hoch, um die Einschränkungen aufzuheben.',
        title: 'Dein Konto ist eingeschränkt',
      },
      'pam:tipico-account-sow-info-uncooperative': {
        action: 'Jetzt Fragen beantworten',
        text: 'Um die Einschränkungen deines Kontos aufzuheben, beantworte ein paar einfache Fragen zu deiner finanziellen Situation. Es dauert weniger als 1 Minute.',
        title: 'Dein Konto ist eingeschränkt',
      },
      'ui-route-disallowed': {
        action: 'Schließen',
        text: 'Bitte gehe zu deinen Kontodetails für mehr Infos.',
        title: 'Dein Konto ist eingeschränkt',
      },
      verify: {
        action: 'Jetzt verifizieren',
        text: 'Dein Konto wird bald eingeschränkt. Verifiziere dich jetzt, um es vollständig freizuschalten.',
      },
    },
    button: {
      moreInfo: 'Mehr Infos',
      startNow: 'Jetzt starten',
      uploadNow: 'Jetzt hochladen',
    },
    discover: {
      discover: 'Entdecken',
    },
    gameLaunch: {
      error: 'Fehler',
      failed: 'Das Spiel konnte nicht gestartet werden.\nBitte versuche es später oder wähle ein anderes Spiel.',
    },
    loggedOut: {
      header: 'Du hast dich ausgeloggt',
      text: 'Bis zum nächsten Mal.',
    },
    quickDeposit: {
      quickDeposit: 'Schnelle Einzahlung',
    },
  },
  productSwitcher: {
    goToTipicoGames: 'Zu Tipico Games',
    goToTipicoSports: 'Zu Tipico Sportwetten',
    moreFromTipico: 'Mehr von Tipico',
    tipicoGamesAppInstall: 'Tipico Games App herunterladen',
    tipicoSportsAppInstall: 'Tipico Sportwetten App herunterladen',
  },
  rewards: {
    accomplished: 'Erfolgreich abgeschlossen',
    allGames: 'Alle Spiele',
    available: 'Verfügbar',
    bonusAmount: 'Bonusbetrag',
    bonusMoney: 'Bonusgeld',
    canceled: 'Storniert',
    canceledOn: 'Storniert am',
    claimed: 'Angebot beansprucht',
    completed: 'Abgeschlossen',
    congratulations: 'Du hast das Angebot erfolgreich umgesetzt und <b>{{amount}}</b> sind jetzt auszahlbar.',
    creditedOn: 'Aktiviert am',
    expired: 'Abgelaufen',
    expiredOn: 'Abgelaufen am',
    expiresOn: 'Läuft ab am',
    forfeit: 'Angebot stornieren',
    freeSpinAmount: 'Gewinne aus Freispielen',
    freeSpinLogout: {
      action: 'Zu den Freispielen',
      expiresAtLabel: 'Läuft ab',
      title: 'Freispiele verfügbar',
    },
    freeSpinWidgetText: 'Du hast Freispiele',
    freeSpins: 'Anzahl der Freispiele',
    freeSpinsAmount: '{{amount}} FS',
    inProgress: 'Läuft',
    maxBonus: 'Max. Bonusbetrag',
    maxFreeSpinBonus: 'Mögliche Freispiele',
    okClear: 'Verstanden',
    optedIn: 'Angemeldet',
    pending: 'Bitte setze erst dein laufendes Angebot um.',
    remaining: 'verbleibend',
    remainingToNextFreeSpin: 'zu den nächsten Freispielen',
    remainingToNextStep: 'zur nächsten Stufe',
    seeAll: 'Alle anzeigen',
    tacTitle: 'Angebotsbedingungen',
    totalToWager: 'Insgesamt umzusetzen',
    unlockedBonusAmount: 'Freigeschaltet',
    unlockedBonusFreeSpins: 'Freigeschaltete Freispiele',
    userHasNoRealMoneyLeft: 'Du hast kein Guthaben.',
    userHasNoRealMoneyLeftLink: 'Jetzt einzahlen',
    validFor: 'Gültig für',
    validTo: 'Gültig bis {{date}}',
    viewCampaignDetails: 'Angebotsdetails',
    viewTAC: 'Bedingungen anzeigen',
    wagered: '{{percent}} % abgeschlossen',
    wageringRequirements: 'Umsatzbedingungen',
  },
  sessionTimeLimit: {
    logout: 'Du wirst jetzt ausgeloggt',
    reached: 'Du hast das Zeitlimit der Sitzung erreicht.',
  },
  sh: {
    a11y: {
      heading: {
        lobby: 'Tipico Casino',
      },
    },
    base: {
      newCustomerModalText:
        'Dein Spielerschutz ist oberste Priorität. Setze dir jetzt Limits und tauche in die offiziell lizenzierte Welt von Tipico Casino ein.',
      newCustomerModalTitle: 'Tauche ein in die Welt von Tipico Casino',
    },
    compliance: {
      coolOffModal: {
        moreInfoMessage2:
          'Falls du gerade bei einem anderen Anbieter eingeloggt warst oder auch bei Tipico Sportwetten, musst du eine 5-minütige Pause machen, bevor du Tipico Casino spielen kannst.',
      },
    },
    footer: {
      helpCenterText:
        '<h3>Support & Kontakt</h3>\n<p>Du hast Fragen zum Tipico Casino oder brauchst Unterstützung?<br>\nUnser Support-Team hilft dir gerne weiter!<br>\nE-Mail: <a href="mailto:kundenservice@tipico-casino.de">kundenservice@tipico-casino.de</a>\n<p><strong>Wichtig</strong>: Bitte sende uns deine Anfrage von der E-Mail-Adresse, die in deinem Konto hinterlegt ist. So können wir dich eindeutig identifizieren und dir schneller weiterhelfen.</p>',
      legalText: 'Mit Genehmigung durch das Innenministerium des Landes Schleswig-Holstein',
      responsibleGaming:
        '<p>Spielteilnahme ab 18 Jahren. Glücksspiel kann süchtig machen. Spiele verantwortungsbewusst. Weitere Informationen findest du auf unserer <a href="https://casino.risk-in-safe-hands.com/" target="_blank">Spielerschutzseite</a>. Beratung und Hilfe für Betroffene und Angehörige gibt es auf <a href="https://bundesweit-gegen-gluecksspielsucht.de" target="_blank">bundesweit-gegen-gluecksspielsucht.de</a> und <a href="https://www.check-dein-spiel.de" target="_blank">www.check-dein-spiel.de</a>. Das Angebot gilt nur für Spielende mit Wohnsitz und Aufenthalt in Schleswig-Holstein.</p>\n<p>Tipico Karlsruhe Ltd. ist eine Gesellschaft mit beschränkter Haftung, die im maltesischen Handelsregister unter der Registernummer C96626 eingetragen ist.\nDer Tipico Karlsruhe Ltd wurde mit Bescheid des Ministeriums für Inneres, Kommunales, Wohnen und Sport des Landes Schleswig-Holstein vom 18.09.2024 die behördliche Erlaubnis für die Veranstaltung und den Eigenbetrieb von Online-Casinospielen in Schleswig-Holstein erteilt.</p>',
    },
    gameInfo: {
      seoMetaDescription:
        'Spiele {{title}} im neun Online Casino in Schleswig-Holstein. Bei Tipico Casino findest du die besten Online Casino Spiele von {{provider}}!',
      seoMetaTitle: 'Spiele {{title}} online um echtes Geld | Tipico Casino',
    },
    navigation: {
      accountMenu: {
        helpCenter: 'Kontakt',
      },
    },
  },
  validator: {
    email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
    required: 'Dieses Feld darf nicht leer sein.',
  },
} as const;
